// test603
(603 && 0);
